import { render, staticRenderFns } from "./schoolDetail.vue?vue&type=template&id=7a509bff&scoped=true"
import script from "./schoolDetail.vue?vue&type=script&lang=js"
export * from "./schoolDetail.vue?vue&type=script&lang=js"
import style0 from "./schoolDetail.vue?vue&type=style&index=0&id=7a509bff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a509bff",
  null
  
)

export default component.exports